import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { formatPrice } from "../utils/formatPrice";

export enum ETransferFormState {
  Initial,
  Validating,
  Validated,
  Submitting,
  Submitted,
}

export interface ITransferFormState {
  amountStr: string;
  errorMsg: string;
  state: ETransferFormState;
  isSuccess: boolean;
  lastTransferAmount: number;
  payoutId: string | null;
  setAmountStr: (amount: string) => void;
  setState: (state: ETransferFormState) => void;
  setErrorMsg: (errorMsg: string) => void;
  getParsedAmount: () => number;
  setSuccess: (isSuccess: boolean, amount?: number) => void;
  setPayoutId: (payoutId: string | null) => void;
  reset: () => void;
}

export const transferFormStoreInitialState = {
  state: ETransferFormState.Initial,
  amountStr: "",
  errorMsg: "",
  isSuccess: false,
  lastTransferAmount: 0,
  payoutId: null,
};

export const useTransferFormStore = create<ITransferFormState>()(
  devtools((set, get) => ({
    ...transferFormStoreInitialState,
    setAmountStr: (amountStr) => {
      const v = amountStr.replace(/\D/ig, "");
      if (!v || Number.isNaN(parseInt(v))) {
        set({ amountStr: "" });
        return;
      }
      const fmt = formatPrice(parseInt(v), 0).replace(/\s₽$/, "");
      set({
        amountStr: fmt,
      });
    },
    setState: (state) => { set({ state }); },
    setErrorMsg: (errorMsg) => { set({ errorMsg }); },
    getParsedAmount: () => {
      const clean = get().amountStr.replace(/\D/ig, "");
      if (clean) {
        return parseInt(clean);
      } else {
        return 0;
      }
    },
    setSuccess: (isSuccess, amount) => {
      set({
        isSuccess,
        lastTransferAmount: amount ?? get().lastTransferAmount,
      });
    },
    setPayoutId: (payoutId) => {
      set({ payoutId });
    },
    reset: () => {
      set({
        ...transferFormStoreInitialState,
        // Preserve lastTransferAmount and isSuccess so status page can show them
        lastTransferAmount: get().lastTransferAmount,
        isSuccess: get().isSuccess,
        // Preserve payoutId so TransferForm can keep polling
        payoutId: get().payoutId,
      });
    },
  }),
  { name: "transfer-form-store" }),
);
